import { motion } from "framer-motion";
import { PROCESS, IMAGES } from "../../data/site";

export const Process = () => (
  <section
    id="process"
    data-testid="process-section"
    className="bg-[#F9F7F4] py-24 md:py-32"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-12 gap-6 mb-16 items-end">
        <div className="col-span-12 lg:col-span-8">
          <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
            How we work
          </div>
          <h2 className="font-display text-[#1C1B1A] text-4xl md:text-5xl lg:text-[4.5rem] leading-[1.02] tracking-tight">
            Three steps.
            <br />
            <span className="font-serif-accent italic text-[#C05746]">One</span> guarantee.
          </h2>
        </div>
        <p className="col-span-12 lg:col-span-4 text-[#5C5A55] text-base md:text-lg leading-relaxed">
          Our process targets the colony — not just surface activity —
          and backs the work with a written warranty.
        </p>
      </div>

      <div className="grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 lg:col-span-7 relative">
          <div
            className="absolute left-7 top-6 bottom-6 w-px bg-[#E5DFD5]"
            aria-hidden="true"
          />
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative pl-20 md:pl-24 pr-2 py-8 border-b border-[#E5DFD5] last:border-b-0"
              data-testid={`process-step-${i}`}
            >
              <div className="absolute left-0 top-8 w-14 h-14 bg-[#1E2C25] text-[#F9F7F4] flex items-center justify-center font-display text-xl tracking-tight">
                {p.n}
              </div>
              <h3 className="font-display text-[#1C1B1A] text-2xl md:text-3xl tracking-tight">
                {p.title}
              </h3>
              <p className="text-[#5C5A55] text-base md:text-lg leading-relaxed mt-3 max-w-xl">
                {p.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="col-span-12 lg:col-span-5 relative"
        >
          <div className="relative aspect-[3/4] overflow-hidden bg-[#2A3B32]">
            <img
              src={IMAGES.technician}
              alt="ATC Pest Control certified technician at work"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C1B1A]/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-[#F9F7F4]">
              <div className="text-[10px] uppercase tracking-[0.24em] text-[#F9F7F4]/70">
                Treatment Systems
              </div>
              <div className="font-display text-xl md:text-2xl mt-2 leading-snug">
                Termidor · Inject-O-Matic 360°
              </div>
            </div>
          </div>
          <div className="hidden lg:block absolute -right-4 -top-4 px-4 py-2 bg-[#C05746] text-[#F9F7F4] font-display text-sm tracking-[0.12em] uppercase">
            Certified
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
